export default class Accordion {
  constructor(elem) {
    this.elem = elem;
    this.trigger = elem.querySelector('.js-accordion-trigger');
    this.content = elem.querySelector('.js-accordion-content');

    if (!this.trigger || !this.content) {
      return;
    }

    const {initialized} = elem.dataset;

    if (!initialized) {
      this.elem.setAttribute('data-initialized', true);
      this.trigger.addEventListener('click', () => this.handleClick());
    }
  }

  handleClick() {
    this.trigger.classList.toggle('is--active');
    this.elem.classList.toggle('is--active'); /** also add the class to the wrapping element, so we can add a border to it. */

    if (this.content.style.maxHeight === 'max-content' || this.content.style.maxHeight === '100%') {
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
      /** fix for animation */
      setTimeout(() => {
        this.content.style.maxHeight = null;
      }, 0)
    } else if (this.elem.dataset.type === 'group') {
      this.content.style.maxHeight = '100%';
    } else {
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;

      /** wait for animation to finish, to set actual max height (so nested content can also expand it) */
      setTimeout(() => {
        this.content.style.maxHeight = 'max-content'
      }, 200);
    }
  }
}
